require('./hireCardECardError.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ commons
const WizardError = require('components/commons/wizardError/wizardError');

// @ constants
const { analyticsId, catalogue } = require('../analytics/hireCardECardAnalytics');

class hireCardECardError extends React.Component {

    render() {
        const { processDetail, hireRestrictionFlag } = this.props;
        const goBackButton = hireRestrictionFlag ? {
            label: (
                <FormattedText
                    value="hireCard-errorRestrictionBackButtonText"
                />
            ),
            url: '/myprofile/global'
        }:{
            label: (
                <FormattedText
                    format="uppercase"
                    value="hireCardECard-errorBackButtonText"
                />
            ),
            url: '/myprofile/cards'
        };
        const textElement = hireRestrictionFlag ? 'hireCard-errorRestrictionSubtitleAccount':'hireCardECard-errorTextGeneric' 
        const cancleButton ={
            label: (
                <FormattedText
                    value="hireCard-errorRestrictionCancleButtonText"
                />
            ),
            url: '/myprofile/cards'
            };
        return (
            <WizardError
                errorMessage={hireRestrictionFlag ? formatText('hireCard-errorRestrictionTitleAccount'): formatText('hireCardECard-errorTitleGeneric')}
                mainButton={goBackButton}
                processDetail={processDetail}
                cancleButton={cancleButton}
                tealium={catalogue[analyticsId.ECOMMERCE_CARD_WIZARD_ERROR]({
                    productName: processDetail, 
                    errorMessage: hireRestrictionFlag ? formatText('hireCard-errorRestrictionTitleAccount'): formatText('hireCardECard-errorTitleGeneric'),
                })}
                isSecondVersion
            >
                <article className="hire-card-ecard-error">
                    <FormattedText value={textElement} />
                </article>
            </WizardError>
        );
    }
}

hireCardECardError.propTypes = {
    processDetail: PropTypes.string,
    hireRestrictionFlag: PropTypes.bool
};

hireCardECardError.defaultProps =
{
    hireRestrictionFlag : false
}

module.exports = hireCardECardError;
